module.exports = __webpack_public_path__ + "img/1.7cd56fa4.jpg";